export default __webpack_public_path__ + "static/media/image33.16094f86.jpg";